import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vnr7n3htee: FaireBrandEntity = {
  token: "b_vnr7n3htee",
  type: "brand",
  name: "Oily Graphic Creations",
  avatarUrl:
    "https://cdn.faire.com/fastly/f1ba9b6185d1b3fe556d5d799ad16279e7a073e304c492d5d2015fe0e303ffbe.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c01b10e63c80aa625862caa0356a6e555afc345f6c4d6d3110f02fc25738af6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f1ba9b6185d1b3fe556d5d799ad16279e7a073e304c492d5d2015fe0e303ffbe.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c01b10e63c80aa625862caa0356a6e555afc345f6c4d6d3110f02fc25738af6c.png",
  location: "Clarksville, TN, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 81,
  isInsider: true,
  description:
    "Oily Graphic Creations started in 2020 as a graphics only business and grew into stickers, UV DTF, and so much more.\n\nWe pride ourselves in quality products and fun designs that can be hard to find with other sticker businesses. We also print all items in house using professional grade materials which is also hard to find with other sticker businesses.\n\nWe are more than happy to design and/or print custom designs for you...just shoot a message our way.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:57.501Z",
    importedBy: "entity-db-cli",
  },
};
